module.exports = __webpack_public_path__ + "img/btn-jc-bg3.7b38aa9e.png";